import gql from 'graphql-tag';

export const HOME_YOUR_COURSES_QUERY = gql`
  query HomeYourCourses {
    user {
      id
      coursesInProgress(first: 5) {
        id
        title
        subtitle
        slug
        totalDays
        daysCompleted
        cloudinaryThumbnail {
          path
        }
        exploreCategory {
          id
          colourTheme
          internalName
        }
      }
    }
  }
`;
